module.exports = __webpack_public_path__ + "img/logo_guangyao.aadbe04c.png";